import { useQuery } from '@tanstack/react-query';
import { McpServerService } from '../../../../service/McpServerService';
import type { McpToolItem } from '../../../../service/McpServerService';

export type McpListToolsQueryInput =
  | { type: 'none' }
  | {
      type: 'integration';
      integrationId: string;
      organizationId: string;
    }
  | { type: 'url'; serverUrl: string; authToken?: string };

export function mcpListToolsQueryKey(input: McpListToolsQueryInput) {
  return ['mcp-list-tools', input] as const;
}

function isValidHttpUrl(url: string): boolean {
  const t = url.trim();
  return t.startsWith('http://') || t.startsWith('https://');
}

export function useMcpListToolsCatalogQuery(input: McpListToolsQueryInput) {
  const enabled =
    input.type === 'integration' ||
    (input.type === 'url' && isValidHttpUrl(input.serverUrl));

  return useQuery({
    queryKey: mcpListToolsQueryKey(input),
    queryFn: async (): Promise<McpToolItem[]> => {
      if (input.type === 'integration') {
        const res = await McpServerService.listTools({
          integrationId: input.integrationId,
          organizationId: input.organizationId,
        });
        return res?.data?.tools ?? [];
      }
      if (input.type === 'url') {
        const res = await McpServerService.listTools({
          serverUrl: input.serverUrl.trim(),
          authToken: input.authToken?.trim() || undefined,
        });
        return res?.data?.tools ?? [];
      }
      return [];
    },
    enabled,
    staleTime: 60_000,
    placeholderData: (previousData: McpToolItem[] | undefined) => previousData,
  });
}

export { isValidHttpUrl };
